import styled from '@emotion/styled';

export const Container = styled.div`
    margin: auto;
    & > * {
        margin-bottom: 3em;
        margin-left: auto;
        margin-right: auto;
    }
`;
